import ModuleRecords from './manage-module/ModuleRecords'
import ModuleRecordsView from './manage-module/View'
import ModuleRecordsCreate from './manage-module/Create'

const Modules = {
    ModuleRecords,
    ModuleRecordsView,
    ModuleRecordsCreate,
}

export default Modules
